// Standard opening and closing cards for the three GroupFaces tutorials, in the demo film's language (same Line,
// Mark, grain and vignette), for approval before the tutorials are rebuilt.
// Opening (4 s): the GroupFaces mark, then "TUTORIAL 0N/03" and the tutorial title. Closing (5.5 s): a generic line
// about photo separation (no "formatura"), then the mark with groupfaces.io. Music only, no voice.
import React from 'react';
import {AbsoluteFill, Img, staticFile} from 'remotion';
import {Fonts} from './Fonts';
import {C, F, ease, easeOut} from './theme';
import {useT} from './data';
import {Line, Mark} from './Film';
import {Post, Shot} from './lens';
import {ramp} from './motion/util';

export const OPENING_S = 4;
export const CLOSING_S = 5.5;
const BG = '#030304';

export type OpeningProps = {index: number; total: number; title: string};
export const Opening: React.FC<OpeningProps> = ({index, total, title}) => {
 const t = useT();
 const kMark = Math.min(ramp(t, 0.2, 0.8, easeOut), 1 - ramp(t, 1.5, 0.5, ease));
 const kLabel = Math.min(ramp(t, 1.7, 0.6, easeOut), 1 - ramp(t, OPENING_S - 0.6, 0.6, ease));
 const kTitle = Math.min(ramp(t, 1.95, 0.7, easeOut), 1 - ramp(t, OPENING_S - 0.6, 0.6, ease));
 const label = `TUTORIAL ${String(index).padStart(2, '0')}/${String(total).padStart(2, '0')}`;
 return <AbsoluteFill style={{background: BG}}><Fonts>
  {kMark > 0 && <AbsoluteFill style={{alignItems: 'center', justifyContent: 'center'}}>
   <Img src={staticFile('brand/logo.svg')} style={{height: 80, width: 'auto', opacity: kMark, filter: `blur(${((1 - kMark) * 10).toFixed(2)}px)`,
    transform: `scale(${(0.95 + 0.05 * kMark).toFixed(4)})`}}/>
  </AbsoluteFill>}
  <AbsoluteFill style={{alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 26}}>
   <div style={{fontFamily: F.mono, fontSize: 22, letterSpacing: '.3em', color: C.accentHi, opacity: kLabel,
    transform: `translateY(${((1 - kLabel) * 10).toFixed(2)}px)`}}>{label}</div>
   <div style={{fontFamily: F.sans, fontSize: 76, fontWeight: 500, letterSpacing: '-.02em', color: C.ink, opacity: kTitle,
    filter: `blur(${((1 - kTitle) * 12).toFixed(2)}px)`, transform: `translateY(${((1 - kTitle) * 14).toFixed(2)}px)`}}>{title}</div>
  </AbsoluteFill>
 </Fonts><Post/></AbsoluteFill>;
};

export type ClosingProps = {line: [string, string]};
export const Closing: React.FC<ClosingProps> = ({line}) => <AbsoluteFill style={{background: BG}}><Fonts>
 <Shot from={0} to={CLOSING_S} inn={0} out={0}>
  <Line a={0.4} b={2.9} parts={[[line[0], C.ink], [line[1], C.accentHi]]}/>
  <Mark a={2.9}/>
 </Shot>
</Fonts><Post/></AbsoluteFill>;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
